import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import { ListaServicos } from './pages/listaServicos';
import { ServicoDetalhe } from './pages/servicoDetalhe';
import FormasPagamento from './pages/formasPagamento';

function ServicosUsuario() {
  let { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <ListaServicos />
      </Route>
      <Route exact path={`${path}/detalhe/:id`}>
        <ServicoDetalhe />
      </Route>
      <Route exact path={`${path}/detalhe/:id/formasPagamento`}>
        <FormasPagamento />
      </Route>
    </Switch>
  );
}

export default ServicosUsuario;
